import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { NotifyChipValueComponent } from "@shared/components/notify-chip/components/notify-chip-value/notify-chip-value.components";
import { NotifyChipComponent } from "@shared/components/notify-chip/notify-chip.component";
import { IconModule } from "@ogs/ngx-m3-components";
import { provideTranslationScope, TranslationPipeModule } from "@ogs-gmbh/ngx-translate";

// TODO: MOVE TO SHARED
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-authenticate-ui-invalid-credentials-notice",
  templateUrl: "invalid-credentials-notice.component.html",
  styleUrl: "invalid-credentials-notice.component.scss",
  standalone: true,
  imports: [ NotifyChipValueComponent,
    NotifyChipComponent,
    IconModule,
    TranslationPipeModule ],
  providers: [
    provideTranslationScope("shared/invalid-credentials-notice")
  ]
})
export class InvalidCredentialsNoticeComponent {
  private readonly faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  constructor () {
    this.faIconLibrary.addIcons(faExclamationTriangle);
  }
}
